import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import OptionsPopover from "@/components/Teeth/OptionsPopover.vue";
let Cell = class Cell extends Vue {
    value;
    hovers;
    condition;
    tooth;
    partIdx;
    x;
    y;
    set;
    stateClass;
    $refs;
    setHover(condition, partIdx) {
        return { [condition]: partIdx };
    }
    valueWatcher(value) {
        if (value.x !== this.x || value.y !== this.y)
            return;
        this.$refs.button.focus();
    }
    focus() {
        this.setHover(this.condition, this.partIdx);
        return { x: this.x, y: this.y };
    }
    get dynamicClasses() {
        let styleClasses = this.condition === 'missing' ? 'badge badge-light badge-pill m-2' : 'btn-sm btn-outline-secondary btn-square';
        return this.stateClass(this.tooth, this.condition) + ' ' + styleClasses;
    }
    get showPopover() {
        return this.value.x === this.x && this.value.y === this.y;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], Cell.prototype, "value", void 0);
__decorate([
    Prop({ type: Object, required: true })
], Cell.prototype, "hovers", void 0);
__decorate([
    Prop({ type: String, required: true })
], Cell.prototype, "condition", void 0);
__decorate([
    Prop({ type: Number, required: true })
], Cell.prototype, "tooth", void 0);
__decorate([
    Prop({ type: Number, required: true })
], Cell.prototype, "partIdx", void 0);
__decorate([
    Prop({ type: Number, required: true })
], Cell.prototype, "x", void 0);
__decorate([
    Prop({ type: Number, required: true })
], Cell.prototype, "y", void 0);
__decorate([
    Prop({ type: Function, required: true })
], Cell.prototype, "set", void 0);
__decorate([
    Prop({ type: Function, required: true })
], Cell.prototype, "stateClass", void 0);
__decorate([
    Emit('update:hovers')
], Cell.prototype, "setHover", null);
__decorate([
    Watch('value', { deep: true })
], Cell.prototype, "valueWatcher", null);
__decorate([
    Emit('input')
], Cell.prototype, "focus", null);
Cell = __decorate([
    Component({
        components: { OptionsPopover }
    })
], Cell);
export default Cell;
